export default function checkMasonry() {
  // 获取 User-Agent 字符串
  const userAgent = navigator.userAgent
  const chromeVersionMatch = userAgent.match(/Chrome\/(\d+)/)
  const chromeVersion = chromeVersionMatch ? parseInt(chromeVersionMatch[1]) : null
  // chrome版本小于96，不支持瀑布流
  return !(chromeVersion && chromeVersion < 96)
}
